import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Downloads one Excel backup per class, in series with a small delay to avoid the
// browser's multi-download throttling. Returns nothing; shows progress via toast.
export async function downloadAllClassBackups(classes) {
  const list = Array.isArray(classes) ? classes : [];
  if (list.length === 0) {
    toast.error('No hay clases para descargar');
    return;
  }
  const token = localStorage.getItem('token');
  const usedNames = new Set();
  let ok = 0;
  let failed = 0;

  const progressId = toast.loading(`Descargando respaldos… 0 de ${list.length}`);

  for (let i = 0; i < list.length; i++) {
    const cls = list[i];
    try {
      const response = await axios.get(`${API}/teacher/classes/${cls.id}/export-excel`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });
      let name = `${cls.subject}_${cls.group}`.replace(/\s+/g, '_');
      if (usedNames.has(name)) name = `${name}_${i + 1}`;
      usedNames.add(name);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      ok += 1;
    } catch (e) {
      failed += 1;
    }
    toast.loading(`Descargando respaldos… ${i + 1} de ${list.length}`, { id: progressId });
    // Space out downloads so the browser doesn't block them.
    if (i < list.length - 1) await new Promise((r) => setTimeout(r, 400));
  }

  toast.dismiss(progressId);
  if (failed === 0) {
    toast.success(`${ok} respaldo${ok === 1 ? '' : 's'} descargado${ok === 1 ? '' : 's'}`);
  } else {
    toast.warning(`${ok} descargado(s), ${failed} con error`);
  }
}
